<template>
  <div class="list_wrap list_wrap_renew">
    <ul class="list tow_colum_type">
      <li>
        <div class="list_title">
          마이팩 명
        </div>
        <div class="list_cont">
          <div class="input_wrap">
            <input
              ref="refInputPackName"
              v-model="renaming"
              type="text"
              class="form_input"
              :disabled="disabledPackName"
              @input="checkPackNameLength"
              @blur="finalizeInput"
            >
            <button
              id=""
              class="btn_default-b"
              :disabled="disabledPackName"
              @click="changePackName"
            >
              변경
            </button>
          </div>
        </div>
      </li>
      <li>
        <div class="list_title">
          {{ isAbc ? '신청ABC' : '신청유형' }}
        </div>
        <div class="list_cont">
          <div class="input_wrap" v-show="isVcall">
            채팅상담
          </div>
          <div class="input_wrap" v-show="isAbc">
            <select
              id="pickupAp"
              v-model="selectedLocation"
              :disabled="!abcFectched || disabledChangeLocation"
              class="form_select"
            >
              <option
                v-for="abc in abcLocation"
                :key="abc.cd"
                :value="abc.cd"
              >{{ abc.cdName }}</option>
            </select>
            <button
              id=""
              class="btn_default-b"
              :disabled="disabledChangeLocation"
              @click="changeABCLocation"
            >
              변경
            </button>
          </div>
        </div>
      </li>
      <li>
        <div class="list_title">
          신청번호
        </div>
        <div class="list_cont">
          {{ appliedStatusDetail.apply_no }}
        </div>
      </li>
      <li>
        <div class="list_title">
          신청일
        </div>
        <div class="list_cont">
          {{ appliedStatusDetail.req_date }}
        </div>
      </li>
      <li>
        <div class="list_title">
          상태
        </div>
        <!-- 상태정보 -->
        <state-detail-progress
          :progress-of-state="appliedStatusDetail.user_status"
          :progress-of-state-name="appliedStatusDetail.user_status_name"
          :order-key="appliedStatusDetail.order_key"
        />
      </li>
      <li>
        <div class="list_title">
          구성
        </div>
        <div class="list_cont">
          <p><em>1일 총 {{ totalPhilsPerDay }}정/캡슐</em>
            <span>(총 {{ totalPockets }}포)</span></p>
        </div>
      </li>
      <li>
        <div class="list_title">
          금액
        </div>
        <div class="list_cont">
          <em><mpn-label-number
            :amount="price"
          /> 원</em>
        </div>
      </li>
      <li class="">
        <div class="list_title">
          PV/BV
        </div>
        <div class="list_cont">
          <span><mpn-label-number
            :amount="pv"
          /></span> / <span><mpn-label-number
            :amount="bv"
          /></span>
        </div>
      </li>
      <li v-if="appliedStatusDetail.billing_period">
        <div class="list_title">정기 구매 기간</div>
        <div class="list_cont">{{ appliedStatusDetail.billing_period }}</div>
      </li>
      <li v-if="appliedStatusDetail.billing_date">
        <div class="list_title">정기 결제일</div>
        <div class="list_cont">{{ appliedStatusDetail.billing_date }}일</div>
      </li>
    </ul>
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import { DOUBLE_X_SKU, PACK_STATUS_CODE } from '@/utils/constants';
import productHelpers from '@/utils/helpers/product';
import { mapGetters } from 'vuex';
import packApi from '@/apis/pack';
import ModalAlert from '@/components/global/ModalAlert';
import StateDetailProgress from './StateDetailProgress.vue';

const chunjiinDot = ['ㆍ', 'ᆢ'];
const disallowedPatternsWhileTyping = /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|ㆍ|ᆢ| ]|\|/g;
const disallowedPatternsFinal = /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9| ]|\|/g;

export default {
  name: 'StateDetail',
  components: {
    StateDetailProgress,
    ModalAlert,
  },
  props: {
    appliedStatusDetail: {
      type: Object,
      default: () => {},
    },
    productsDetails: {
      type: Array,
      default: () => [],
    },
    disabledPackName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedLocation: '',
      renaming: '',
    };
  },
  computed: {
    ...mapGetters({
      abcLocation: 'common/abc',
      abcFectched: 'common/abcFectched',
    }),
    disabledChangeLocation() {
      if (this.appliedStatusDetail.pack_status !== PACK_STATUS_CODE.CONSULTATION_FINISHED &&
        this.appliedStatusDetail.pack_status !== PACK_STATUS_CODE.CONSULTATION_CANCELED &&
        this.appliedStatusDetail.pack_status !== PACK_STATUS_CODE.CONSULTATION_INCOMPLETED) {
        return false; // enable
      }
      return true; // disabled
    },
    totalPockets() {
      if (this.productsDetails !== null) {
        return this.appliedStatusDetail.take_days * this.productsDetails[0].pockets;
      }
      return 0;
    },
    price() {
      if (this.appliedStatusDetail.order_total_price) {
        return parseInt(this.appliedStatusDetail.order_total_price, 10);
      }
      return this.appliedStatusDetail.total_price;
    },
    pv() {
      if (this.appliedStatusDetail.order_total_pv) {
        return parseInt(this.appliedStatusDetail.order_total_pv, 10);
      }
      return this.appliedStatusDetail.total_pv;
    },
    bv() {
      if (this.appliedStatusDetail.order_total_bv) {
        return parseInt(this.appliedStatusDetail.order_total_bv, 10);
      }
      return this.appliedStatusDetail.total_bv;
    },
    totalPhilsPerDay() {
      console.log(this.productsDetails);
      if (this.productsDetails !== null) {
        return this.productsDetails.reduce(
          (acc, n) => acc + productHelpers
            .parseSeq(n.seq)
            .reduce((acc2, x) => acc2 + (n.item_sku === DOUBLE_X_SKU ? x * 3 : x),
              0),
          0,
        );
      }
      return {};
    },
    isVcall() {
      return this.appliedStatusDetail.cfm_kind === 'VCALL'
    },
    isAbc() {
      return this.appliedStatusDetail.cfm_kind === 'ABC'
    },
  },
  watch: {
    appliedStatusDetail() {
      this.selectedLocation = this.appliedStatusDetail.abc_cd;
      this.renaming = this.appliedStatusDetail.mypack_name;
    },
  },
  methods: {
    async changePackName() {
      if (this.renaming.length === 0) {
        await this.$refs.refAlert.openWithMessage('변경하시고 싶은 팩 이름을 입력해주세요.');
        return;
      }
      const result = await packApi.changePackName(this.appliedStatusDetail.req_no, this.renaming);
      if (result === 'Duplicate pack name') {
        await this.$refs.refAlert.openWithMessage('팩 이름이 중복되었습니다.');
        return;
      }
      if (result === 'S') {
        await this.$refs.refAlert.openWithMessage('팩 이름이 변경 되었습니다.');
      } else {
        await this.$refs.refAlert.openWithMessage(result);
      }
      this.$emit('change-packname');
      this.renaming = '';
    },
    async changeABCLocation() {
      if (this.selectedLocation === this.appliedStatusDetail.abc_cd) {
        await this.$refs.refAlert.openWithMessage('현재 진행중인 ABC 입니다.');
        return;
      }
      if(this.selectedLocation==='daegu') {
        const message = [
          "대구ABC 매장 내 '마이팩 랩'이 4월 30일(수)부로 운영을 종료합니다.",
          "· 대구ABC 내 '마이팩 랩' 서비스 종료 : 4월 30일(수)",
          "· 대구ABC 신규 픽업 신청 마감 : 4월 25일(금)",
          "기존 생성된 신청 픽업은 4월 30일(수) 오후 5시까지 가능합니다."
        ].join('\n');
        await this.$refs.refAlert.openWithMessage(message);
      }
      const result = await packApi
        .changeABCLocation(this.appliedStatusDetail.req_no, this.selectedLocation);

      console.log(result);
      await this.$refs.refAlert.openWithMessage('신청 ABC가 변경 되었습니다.');
      this.$emit('change-packname');
      this.renaming = '';
    },
    checkPackNameLength(evt) {
      if (this.renaming === ' ') {
        this.renaming = '';
        return;
      }
      console.log(evt.target.value);
      const valueInput = evt.target.value;
      const last = valueInput.slice(valueInput.length - 1, valueInput.length);
      if (valueInput.length > 0 && chunjiinDot.includes(last)) {
        // 천지인 컴포지션 중이라 간주.
        return;
      }

      const preceding = valueInput.slice(0, valueInput.length - 1);

      console.log(preceding, ' - ', last);
      const val = (preceding ? preceding.replace(disallowedPatternsFinal, '') : '')
        + last.replace(disallowedPatternsWhileTyping, '');

      console.log(val);
      if (val.length > 10) {
        this.renaming = val.slice(0, 10);
        // 한글은 자소의 조합이 IME를 통해 입력되므로 한 글자의 입력완료여부가 불투명함
        // 또한, 입력값이 변경 된 후 실제 조작된 데이터와 화면에 보이는 입력값이 다르게 보이는 순간이 존재하므로,
        // 강제로 input 요소를 업데이트 해줘야 함.
        this.$refs.refInputPackName.value = this.renaming;
      } else {
        this.renaming = val;
      }
    },
    finalizeInput() {
      this.renaming = this.renaming.replace(disallowedPatternsFinal, '');

      if (this.renaming.length > 10) {
        this.renaming = this.renaming.slice(0, 10);
      }
      this.$refs.refInputPackName.value = this.renaming;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/mypacks/detail/partial/recent-part/StateDetail.vue